<template>
  <div class="view-component">
    <navbar :type="type" />

    <div class="container">
      <h1 class="title">Create {{ metadata.entityName | toTitleCase }}</h1>

      <div class="box">
        <div class="columns is-centered" v-if="showTags">
          <div class="column is-half">
            <b-field label="Tags">
              <b-taginput
                :value="data.tags"
                @input="setTags"
                :data="tagsAutofill"
                autocomplete
              ></b-taginput>
            </b-field>
          </div>
        </div>

        <form-wizard
          :data="data"
          :fields="fields"
          :metadata="metadata"
          use-masonry
          @submit="onSubmit"
        ></form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'
import Navbar from './Navbar.vue'

import _ from 'lodash'

export default {
  name: 'CreateComponent',

  props: {
    type: {
      required: true
    }
  },

  data () {
    return {
      data: {}
    }
  },

  created () {
    if (this.$route.query) {
      this.data = {
        ...this.data,
        ...this.$route.query
      }
    }
  },

  methods: {
    async onSubmit (data) {
      const loader = this.$loading.open()

      try {
        const response = await this.$entity.create(this.type, data)

        this.$entity.toView(this.type, response.data.id)
      } catch (e) {
        console.error(e)
        this.$snackbar.open({
          duration: 5000,
          message: `Could not create ${Library.Filters.toTitleCase(this.type)}, try again later.`,
          type: 'is-danger',
          actionText: null
        })
      } finally {
        loader.close()
      }
    },

    setTags (e) {
      this.$set(this.data, 'tags', e)
    }
  },

  computed: {
    metadata () {
      return this.$store.getters['metadata/findMetaData'](this.type)
    },

    fields () {
      const fields = Library.Entities.getCreateFields(this.type)

      if (_.isObject(fields) && _.isArray(fields.fields)) {
        return fields.fields
      } else if (_.isFunction(fields)) {
        return fields()
      } else {
        return fields
      }
    },

    showTags () {
      if (this.metadata && this.metadata.properties && this.metadata.properties.find(prop => prop.propertyName === 'tags')) {
        return true
      } else {
        return false
      }
    },

    tagsAutofill () {
      if (this.showTags) {
        const autofill = this.metadata.properties.find(prop => prop.propertyName === 'tags');

        return autofill.options.possibleValues || []
      }
    }
  },

  components: {
    FormWizard: Library.Components.FormWizard,
    Navbar
  }
}
</script>
